import axios from 'axios';
import { configApi } from '../../api/configApi';
import { router } from '../../main.js';
import { headers, headersMultipart } from '../../api/headers';
import { store } from '../index';
import { method } from 'lodash';

export default {
  namespaced: true,
  state: {
    imagenes: [],
    generos: [],
    imagen: null,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 0,
      sortBy: '',
      totalItems: 0,
      rowsPerPageItems: [1, 2, 4, 8, 16],
    },
    pages: 0,
    loading: false,
  },
  getters: {
    listImagenes: (state, getters, rootState) => {
      return state.imagenes;
    },
    imagen: (state, getters, rootState) => {
      return state.imagen;
    },
    pagination(state, getters, rootState) {
      return state.pagination;
    },
    pages(state, getters, rootState) {
      return state.pages;
    },
    totalItemCount(state, getters, rootState) {
      return state.pagination.totalItems;
    },
    loading(state, getters, rootState) {
      return state.loading;
    },
  },
  mutations: {
    listImagenes: (state, imagenes) => {
      state.imagenes = imagenes.data;
      state.pagination.totalItems = imagenes.total;
      state.pagination.page = imagenes.current_page;
      state.pagination.rowsPerPage = imagenes.per_page;
    },
    viewImagen(state, id) {
      let auxImagen = state.imagenes.filter((item) => item.id == id);
      state.imagen = auxImagen[0];
    },
    listImagenesSearch: (state, imagenes) => {
      if (imagenes != null) {
        state.imagenes = imagenes;
      } else {
        state.imagenes = null;
      }
    },
    setImagen(state, imagen) {
      state.imagen = imagen;
    },
    pages(state) {
      if (
        state.pagination.rowsPerPage == null ||
        state.pagination.totalItems == null
      ) {
        state.pages = 0;
      }

      state.pages = Math.ceil(
        state.pagination.totalItems / state.pagination.rowsPerPage
      );
    },
  },
  actions: {
    listImagenes({ state, getters, commit, rootState }) {
      state.loading = true;
      axios
        .get(`${configApi.apiUrl}imagen`, null, { headers: headers })
        .then((response) => {
          //console.log(response.data.data);
          commit('listImagenes', response.data.data);
          commit('pages');
          state.loading = false;
        })
        .catch((error) => {
          state.loading = false;
          swal('Error!', 'Error al obtener las imagenes!', 'error');
          console.error(error);
        });
    },
    newImagen({ state, getters, commit, rootState }, fileImage) {
      
      store.dispatch('validateToken');
      return axios
        .post(`${configApi.apiUrl}imagen`, fileImage, {
          headers: headersMultipart,
        })
        .then((response) => {
          /*swal("Exito!", "Se creo la imagen correctamente!", "success");*/
          store.dispatch('imagen/listImagenes', state.pagination.page);
          commit('setImagen', response.data.data);
        })
        .catch((error) => {
          swal('Error!', 'Error al crear la imagen!', 'error');
          console.error(error);
        });
    },
    newImagen64({ state, getters, commit, rootState }, payload) {
      // imagen
      // nombre
      store.dispatch('validateToken');
      swal({
        title: 'Cargando espere por favor...', allowOutsideClick: false,
      })
  
      if(payload.metodo == 'Nuevo'){

        const formData = new FormData();
        formData.append(
          'imagen[]',
          payload.imagen
        );
        formData.append('metodo', payload.metodo);
        formData.append('nombre', payload.nombre);

        return axios
        .post(`${configApi.apiUrl}save_base64`, formData, { headers: headersMultipart })
        .then((response) => {
          //console.log(response);
          
            swal("Exito!", "Se crearon las imagénes correctamente!", "success");
          //commit('setImagen', response.data.data);
        })
        .catch((error) => {
          swal('Error!', 'Error al crear la imagen!', 'error');
          console.error(error);
        });
        
      }else{
        return axios
        .post(`${configApi.apiUrl}save_base64`, payload, { headers: headersMultipart })
        .then((response) => {
          /*swal("Exito!", "Se creo la imagen correctamente!", "success");*/ 
          /* store.dispatch('imagen/listImagenes',state.pagination.page); */
          //console.log('Imprimiendo el response', response);
          commit('setImagen', response.data.data);
        })
        .catch((error) => {
          swal('Error!', 'Error al crear la imagen!', 'error');
          console.error(error);
        });
      }
    },
    base64ToFile(base64String, filename, mimeType) {
      let arr = base64String.split(',');
      let bstr = atob(arr[arr.length - 1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mimeType });
    },
    newImagen64_2023({ state, getters, commit, rootState }, payload) {
      // imagen
      // nombre

      //console.log('esto es lo que envio', payload);
      
      store.dispatch('validateToken');
      return axios
        .post(`${configApi.apiUrl}save_base64`, payload, { headers: headers })
        .then((response) => {
          //console.log(response);
          
          store.state.urlimagenlocalidad = response.data.data.url;
          /*swal("Exito!", "Se creo la imagen correctamente!", "success");*/
          store.dispatch('imagen/listImagenes', state.pagination.page);
          commit('setImagen', response.data.data);
        })
        .catch((error) => {
          swal('Error!', 'Error al crear la imagen!', 'error');
          console.error(error);
        });
    },
    updateImagen({ state, getters, commit, rootState }, payload) {
      // imagen
      store.dispatch('validateToken');
      axios
        .put(`${configApi.apiUrl}updateImage/${payload.id}`, payload, {
          headers: headers,
        })
        .then((response) => {
          swal('Exito!', 'Se actualizo la imagen correctamente!', 'success');
          store.dispatch('condicion/listImagenes', state.pagination.page);
        })
        .catch((error) => {
          swal('Error!', 'Error al actualizar la imagen!', 'error');
          console.error(error);
        });
    },
  },
  methods:{
    formDataToJson(formData) {
      const object = {};
      formData.forEach((value, key) => {
        object[key] = value;
      });
      return object;
    },
  }
};
